import { memo } from 'react';

function TrailerLength(props) {
  const { color = '#666666', size = 16 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1304 6.74316L9.39697 8.50098V7.30566H4.52393V8.50098L2.51416 6.74316L4.52393 4.98633V6.13965H9.39697V4.98633L11.1304 6.74316Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8062 10.2197H15.0249V11.6992H6.89111C6.89096 12.9263 5.90035 13.9176 4.67334 13.918C3.44601 13.918 2.45474 12.9265 2.45459 11.6992H0.975098V3.56641C0.975098 2.75307 1.64126 2.08792 2.45459 2.08789H12.8062V10.2197ZM4.67334 10.96C4.26678 10.96 3.93329 11.2927 3.93311 11.6992C3.93326 12.1058 4.26676 12.4385 4.67334 12.4385C5.07961 12.4381 5.41147 12.1055 5.41162 11.6992C5.41144 11.2929 5.07959 10.9603 4.67334 10.96ZM2.45459 10.2197H3.03174C3.43838 9.76908 4.0156 9.48145 4.67334 9.48145C5.33113 9.48165 5.90841 9.76884 6.31494 10.2197H11.3267V3.56641H2.45459V10.2197Z"
        fill={color}
      />
    </svg>
  );
}
export default memo(TrailerLength);
